import { apiService } from './api';
import { ItemCategory, CreateItemCategoryRequest, ApiResponse } from '../types';

export const itemCategoryService = {
  async getCategories(org: string, restaurantId?: string): Promise<ItemCategory[]> {
    const response = await apiService.get<ItemCategory[]>('/item-categories', { org, ...(restaurantId && { restaurantId }) });
    return response.data;
  },

  async getActiveCategories(org: string, restaurantId?: string): Promise<ItemCategory[]> {
    const response = await apiService.get<ItemCategory[]>('/item-categories', { org, active: true, ...(restaurantId && { restaurantId }) });
    return response.data;
  },

  async getCategory(id: string): Promise<ItemCategory> {
    const response = await apiService.get<ItemCategory>(`/item-categories/${id}`);
    return response.data;
  },

  async createCategory(data: CreateItemCategoryRequest): Promise<ItemCategory> {
    const response = await apiService.post<ItemCategory>('/item-categories', data);
    return response.data;
  },

  async updateCategory(id: string, data: Partial<CreateItemCategoryRequest>): Promise<ItemCategory> {
    const response = await apiService.put<ItemCategory>(`/item-categories/${id}`, data);
    return response.data;
  },

  async toggleCategoryStatus(id: string): Promise<ItemCategory> {
    const response = await apiService.patch<ItemCategory>(`/item-categories/${id}/active`);
    return response.data;
  },

  async deleteCategory(id: string): Promise<ApiResponse<null>> {
    const response = await apiService.delete<ApiResponse<null>>(`/item-categories/${id}`);
    return response.data;
  },

  async hardDeleteCategory(id: string): Promise<ApiResponse<null>> {
    const response = await apiService.delete<ApiResponse<null>>(`/item-categories/${id}/hard`);
    return response.data;
  }
};
